import React, { Component } from 'react';
import PhoneInput from 'react-phone-input-2';
import { isEmpty } from 'lodash';
import LocationAutosuggest from 'components/site/location-autosuggest';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, } from '@cargomatic/ui';
import CargomaticInput from 'components/v2/input';
import { Trans, withTranslation } from 'react-i18next';
import { ControlLabel } from 'react-bootstrap';
class OutgateConfirmationModal extends Component {
    constructor() {
        super();
        this.handleInputChange = (field) => (value) => this.setState({ [field]: value });
        this.handleSave = () => {
            const { address, name, suite_or_apt, contact_name, contact_phone } = this.state;
            const payload = {
                completedStopId: this.props.stop._id,
                location: Object.assign(Object.assign({}, address), { name,
                    suite_or_apt }),
                contacts: [
                    {
                        name: contact_name,
                        phone: contact_phone,
                    },
                ],
            };
            this.props.onSave(payload);
        };
        this.requiredOutgateModalDetailsProvided = () => {
            const { name, address } = this.state;
            return name && address && !isEmpty(address);
        };
        this.getModalBody = () => {
            const { t } = this.props;
            return (React.createElement("div", { "data-testid": "div-36853a5f", className: "grid grid-cols-4 gap-4" },
                React.createElement("div", { "data-testid": "div-c4b79ea1", className: "col-span-3" },
                    React.createElement(Trans, { i18nKey: "NAME_REQUIRED", components: [
                            React.createElement(ControlLabel, null),
                            React.createElement("small", { "data-testid": "small-999dc25b", className: "text-muted" }),
                        ] }),
                    React.createElement(CargomaticInput, { dataTestId: "CargomaticInput-bbc8630c", type: "text", placeholder: t('NAME'), onChange: this.handleInputChange('name') })),
                React.createElement("div", { "data-testid": "div-97c376a4", className: "col-span-2" },
                    React.createElement(Trans, { i18nKey: "ADDRESS_REQUIRED", components: [
                            React.createElement(ControlLabel, null),
                            React.createElement("small", { "data-testid": "small-511625f6", className: "text-muted" }),
                        ] }),
                    React.createElement(LocationAutosuggest, { id: "address-autosuggest", className: "mt-1", searchField: "address", callbackSelectedItem: this.handleInputChange('address'), placeholderText: t('SEARCH_FOR_ADDRESS') })),
                React.createElement("div", { "data-testid": "div-9c23f176", className: "col-span-2" },
                    React.createElement(CargomaticInput, { dataTestId: "CargomaticInput-6c485a2b", label: t('SUITE_APT'), placeholder: t('SUITE_APT'), type: "text", onChange: this.handleInputChange('suite_or_apt') })),
                React.createElement("div", { "data-testid": "div-84ed5dc9", className: "col-span-2" },
                    React.createElement(CargomaticInput, { dataTestId: "CargomaticInput-2749226b", label: t('CONTACT_NAME'), placeholder: t('CONTACT_NAME'), type: "text", onChange: this.handleInputChange('contact_name') })),
                React.createElement("div", { "data-testid": "div-0b6469c3", className: "col-span-2" },
                    React.createElement("label", { "data-testid": "label-0665c5af", className: "form-label mb-1" }, t('CONTACT_PHONE')),
                    React.createElement(PhoneInput, { containerClass: "mt-1", inputStyle: { width: '100%' }, inputProps: "", country: COUNTRY_CODE, placeholder: "555-555-5555", value: "", onChange: this.handleInputChange('contact_phone'), id: "phone" }))));
        };
        this.getModalFooter = () => {
            const { t } = this.props;
            return (React.createElement("div", { "data-testid": "div-0c0650f6", className: "flex justify-end space-x-2" },
                React.createElement("button", { "data-testid": "button-1d98157c", type: "button", className: "button button-secondary", onClick: this.props.onCancel }, t('CANCEL')),
                React.createElement("button", { "data-testid": "button-fc9ac78b", type: "button", className: "button button-green", onClick: this.handleSave, disabled: !this.requiredOutgateModalDetailsProvided() }, t('CONFIRM'))));
        };
        this.state = {
            name: '',
            address: {},
            suite_or_apt: '',
            contact_name: '',
            contact_phone: '',
        };
    }
    render() {
        const { t } = this.props;
        return (React.createElement(Dialog, { open: this.props.show, onOpenChange: this.props.onHide },
            React.createElement(DialogContent, { className: "sm:max-w-[600px]" },
                React.createElement(DialogHeader, null,
                    React.createElement(DialogTitle, null, t('ADDITIONAL_STOP_INFO'))),
                this.getModalBody(),
                React.createElement(DialogFooter, null, this.getModalFooter()))));
    }
}
export default withTranslation()(OutgateConfirmationModal);
